exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".togs_of[data-v-0eafd965]{margin:0;text-align:center;text-transform:capitalize}.community_chanel[data-v-0eafd965]{text-transform:uppercase;text-align:center;margin:0}.humtog_s[data-v-0eafd965]{margin-bottom:27px}.comtt_c[data-v-0eafd965]{border-left:none!important}.community_togs[data-v-0eafd965]{padding-left:15px!important;list-style-type:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0eafd965","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/auth/NewRightSidebar.vue
// module id = ga1l
// module chunks = 0